import { getEkardoApolloClient } from '@netfront/common-library';
import {
  GET_CONTENT_PAGE_BY_URL_QUERY,
  IGetContentPageByUrlQueryGraphQLResponse,
  IGetContentPageByUrlQueryVariables,
  ISearchContentGroupsQueryGraphQLResponse,
  ISearchContentGroupsQueryVariables,
  SEARCH_CONTENT_GROUPS_QUERY,
} from '@netfront/ekardo-content-library';
import { GetStaticPathsResult, NextPage, GetStaticProps } from 'next';

import { ContentPage } from '../components';
import { ContentPageProps } from '../components/Pages';
import { STATIC_PAGE_REGENERATION_TIME_IN_SECONDS } from '../constants';
import { IStaticPropsContextParams } from '../interfaces';

const ContentNextPage: NextPage<ContentPageProps> = ({ contentPage }) => {
  return <ContentPage contentPage={contentPage} />;
};

export async function getStaticPaths(): Promise<GetStaticPathsResult> {
  const client = getEkardoApolloClient({
    product: 'KANZI',
  });

  const {
    data: {
      contentGroup: { searchContentGroups },
    },
  } = await client.query<ISearchContentGroupsQueryGraphQLResponse, ISearchContentGroupsQueryVariables>({
    query: SEARCH_CONTENT_GROUPS_QUERY,
    variables: {
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      type: 'PAGE',
    },
  });

  const [contentPages] = searchContentGroups.map((contentGroup) => contentGroup.contentPages);

  const paths = contentPages.filter(({ status }) => status === 'PUBLISHED').map(({ url: pageUrl }) => ({
    params: {
      pageUrl,
    },
  }));

  return {
    fallback: false,
    paths,
  };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { pageUrl } = params as IStaticPropsContextParams;

  const client = getEkardoApolloClient({
    product: 'KANZI',
  });

  const {
    data: {
      contentPage: { getContentPageByUrl: contentPage },
    },
  } = await client.query<IGetContentPageByUrlQueryGraphQLResponse, IGetContentPageByUrlQueryVariables>({
    query: GET_CONTENT_PAGE_BY_URL_QUERY,
    variables: {
      contentPageUrl: String(pageUrl),
      projectId: String(process.env.REACT_APP_PROJECT_ID),
    },
  });

  return {
    props: {
      contentPage,
    },
    revalidate: STATIC_PAGE_REGENERATION_TIME_IN_SECONDS,
  };
};

// eslint-disable-next-line import/no-default-export
export default ContentNextPage;
